<template>
<div>
    <div id="media-menu" class="custom-scroller" :class="[{ 'active' : $store.state.navStates.isMediaNavOpen}, this.mediatype]">
        <div class="closer"><img src="~@/assets/icons/close-x.svg" alt=""  @click.stop="hideMenu" /></div>
        <ul>
            <li v-for="l0Item in tocJson" :key="l0Item.href" >                
                <span v-html="l0Item.text" ></span>
                <ul  class="media-child">
                    <li  v-for="l1Item in l0Item.level1" :key="l1Item.href" @click.stop="l1Item.href ? getMediaItemId (l1Item) : l1Item.isShow = !l1Item.isShow" :class="{selected:l1Item.href == actMediaItem.href}">                            
                        <img v-if="l1Item.type === 'audio'" src="~@/assets/icons/audio.svg" alt=""   />
                        <img v-if="l1Item.preview" :src="`/images/video/${l1Item.preview}`" >
                        <span class="media-label" v-html="l1Item.title" ></span>  
                        <div class="mobile-nav-toggle"  v-if="l1Item.class === 'sub'" @click.stop="l1Item.isShow = !l1Item.isShow"><i class="zf zf-chevron-right"></i></div>
                    </li>
                </ul> 
            </li>
        </ul>
    </div>
    </div>
</template>

<script>
    export default {
        name: "MediaMenu",
        props: ['mediatype', 'tocJson'],
          data() {
            return {
              // results: [],
              actMediaItem: this.$store.state.mediaItem,
              level0: []
            };
          },   
        methods:{ 
        hideMenu() {
          this.$store.commit('changeArchiveNavState', {'active': false, 'type': 'Media'} ) 
        },
        getMediaItemId: function(id) { 
          this.$store.commit('changeArchiveNavState', {'active': false, 'type': 'Media'} )
          let mediaItem = {
            type: id.type, 
            title: id.title,
            href: id.href, 
            preview: id.preview,
            text: id.text
            }
          this.$store.commit('updateMediaItem',mediaItem)
          this.$emit('clickedNavId', 'media')
        },
        //openMenuSection (event) { }
        }        
      }
    
</script>

<style lang="scss">
//@import "@/assets/css/textcommons.scss";
@import "@/assets/css/_variables.scss";
#media-menu {
    position:fixed;
    top:0px;
    left: -800px;
    width:450px;
    height: 100vh;
    overflow-y: auto;
    transition: left .5s ease-out;
    background-color:white;
    border-right: 0.14rem solid #777;
    padding: 8px;
    padding-left: 20px;
    padding-top: 30px;
    padding-right: 20px;
    z-index: 3;
    text-align:left;
    max-width: 450px;
    margin: 0 auto;

    ul li {
      &.selected {
        color: $color-red;
      }
    }

    &.active{
        transition: left .3s ease-in;
        left: 0px;
    }
    .closer {
      position: absolute;
      right: 5px;
      top: 0px;
      cursor: pointer;
    }
    .media-label {
      display: block;
      margin: .21rem 0;
      font-size: .91rem;
      line-height: 1.1rem;
      font-weight: normal;
      font-family: $font-family-herausgeber-medium;
    }

  .media-child {
    height:auto;
    display: grid;
    grid-gap: 10px;

    grid-template-columns: 50% 50%;
    padding: 10px 10px 10px 0;
      
    img {
        width:100%;
    }
 
  }
  &.sound .media-child  img {width: 15%;}
    ul {
        cursor: pointer;
        list-style: none;
        padding:0;
        li {
           // border-bottom: 0.14rem solid  #777;;
            display: block;
            position: relative;
            //padding: 5px 15px 5px 0;
            font-family: $font-family-herausgeber-medium;
            font-size: 1.2rem;
            line-height: 1.3rem;
            margin: 0;

             li:hover {
              color: $color-red;
              li {                  
                color: #777;
                &.selected {
                  color: $color-red;
                }
                li:hover {
                  color: $color-red;
                }
              }
            }
            .mobile-nav-toggle {
                font-size:20px;
                font-weight: bold;
                position: absolute;
                padding:6px;
                top: 5px;
                right: 5px;
                .zf {
                    width: .71rem;
                    height: .711rem;
                    display:block;                    
                    &.zf-chevron-right{
                        background: url('~@/assets/icons/next.svg');
                    }
                }
            }
            }

            //li > ul {margin:0; padding:0;  border-top: 1px solid #777;}
            //li > ul > li:first-child {border:0;}
            li > ul > li {
                font-family: $font-family-herausgeber-regular ;
                font-size: 1rem;
                //margin-left:20px;
                border-bottom:0;
                padding-bottom: 20px;
               // border-top: 0.1rem solid #777;
            }
        }

}

.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

</style>